<template>

  <v-menu :close-on-content-click="true"  v-model="menu" transition="scale-transition" offset-y full-width :nudge-right="40"
    max-width="290px;">

    <v-text-field   @input="returnvalue()"    slot="activator" append-icon="event" :label="etiket" v-model="dateFormatted"  v-on:change="onChange" mask="##.##.####"  @blur="date = parseDate(dateFormatted)"></v-text-field>
    <v-date-picker locale="tr" v-model="date"   @input="dateFormatted = formatDate($event)" no-title scrollable actions>
      <v-spacer></v-spacer>
    </v-date-picker>
  </v-menu>

</template>


<script>

  export default {
    props: ["value", "etiket"],

    data() {
      return {
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
      }
    },
    beforeMount: beforeMount,

    watch: {

    },
    methods: {
      returnvalue() {
      this.$emit('input', this.date  )
    },

    returnfocus()
    {
      this.$emit('blur', parseDate(this.dateFormatted)  )
    }
    ,
    parseDate: parseDate,
    formatDate: formatDate,
    onChange: onChange,

    getDateNow: getDateNow,
    getDateNow1: getDateNow1
    }
  }

function beforeMount(){
this.date=getDateNow()
this.dateFormatted=getDateNow1()
}

  function parseDate(date) {


    var str = date
    var n = str.search('-')
    var m = str.length
    if (n == 1) {


      const [month, day, year] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    } else if (m == 8) {
      return this.date

    }
  }

  function formatDate(date) {

    var str = date
    var n = str.search('.')
    if (n == 1) {
      //  return null
    } else {


      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    }
  }


  function onChange(v) {

    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null
      }
    } else {
      this.dateFormatted = null
    }
  }

    function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }



</script>
